import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    createUserRole: [],
    loading: false,
    error: null,
}

const createUserRoleSlice = createSlice({
    name: "createUserRole",
    initialState,
    reducers: {
        fetchCreateUserRoleSuccess: (state, action) => {
            state.loading = false
            state.createUserRole = action.payload;
        },
        fetchCreateUserRoleFailure: (state, action) => {
            state.loading = false
            state.error = action.payload;
        },
    },
})

export const {
    fetchCreateUserRoleSuccess,
    fetchCreateUserRoleFailure,
} = createUserRoleSlice.actions;

export default createUserRoleSlice.reducer;